module.exports = __webpack_public_path__ + "img/item10.c42862c4.svg";